var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PrescriptionItem } from './components/PrescriptionItem';
export var PrescriptionPrintPage = function (props) {
    return (_jsx("div", { children: props.items.map(function (item, index) { return (_jsx(PrescriptionItem, __assign({}, item, { fonts: props.fonts }), index)); }) }));
};
